if (!customElements.get('drawer')) {
  class DrawerElement extends HTMLElement {
    constructor() {
      super();
      this.closeButton = this.querySelector('.js-offcanvas-close'); 
      this.boundToggleDrawer = this.toggleDrawer.bind(this);
      this.open = false;
    }

    connectedCallback() {
      this.id = this.dataset.id ?? '';
      this.openButton = this.closest('aside.facets-wrapper').querySelector(`[data-drawer-open="${this.id}"]`);
      if(this.classList.contains('drawer-v2')) {
        this.directFilterOpeners = this.openButton.closest('.filter-drawer-opener-wrapper').querySelectorAll('.direct-filter-opener');
        this.directFilterOpeners.forEach(opener => {
          opener.addEventListener('click', this.handleDirectFilterOpenerClick.bind(this));
        });
      }
      this.overlay = this.closest('aside.facets-wrapper').querySelector(`[data-drawer-id="${this.id}"]`);
      if (this.overlay) this.overlay.addEventListener('click', this.boundToggleDrawer);
      if (this.closeButton) this.closeButton.addEventListener('click', this.boundToggleDrawer);
      if (this.openButton) this.openButton.addEventListener('click', this.boundToggleDrawer);
    }

    disconnectedCallback() {
      if (this.overlay) this.overlay.removeEventListener('click', this.boundToggleDrawer);
      if (this.closeButton) this.closeButton.removeEventListener('click', this.boundToggleDrawer);
      if (this.openButton) this.openButton.removeEventListener('click', this.boundToggleDrawer);
    }

    handleDirectFilterOpenerClick(event) {
      let filterHandle = event.currentTarget.dataset.target;
      const filterRow = this.querySelector(`.accordion_item[data-filter="${filterHandle}"]`);
      const customAccordionEl = filterRow.closest('custom-accordion');
      customAccordionEl.open(filterRow);
      const component = this;
      setTimeout(() => {
        component.toggleDrawer();
      },200);
    }

    toggleDrawer() {
      this.classList.toggle('is-expanded');
      this.open = !this.open;

      if(this.open && this.overlay) {
        this.overlay.classList.add('has-open-drawer');
        document.body.style.overflow = 'hidden';
      } else if(!this.open && this.overlay) {
        this.overlay.classList.remove('has-open-drawer');
        document.body.style.overflow = 'auto';
      }
    }
  }

  customElements.define('drawer-element', DrawerElement);
}
